<template>
  <section v-loading="loading" class="attachment-popup-body">
    <div class="attachment-upload-button justify-space-between">
      <div class="category-select" v-if="!isCaseCompleted">
        <el-select
          clearable
          filterable
          default-first-option
          placeholder="Select Category"
          v-model="category"
          allow-create
        >
          <el-option
            v-for="attach in this.attachmentsOptions"
            :label="attach"
            :value="attach"
            :key="attach"
          ></el-option>
        </el-select>
      </div>
      <el-upload
        name="logo"
        action
        :on-change="uploadFile"
        :show-file-list="false"
        :auto-upload="false"
      >
        <el-button
          class="btn radius-button round-button"
          v-if="!isCaseCompleted"
        >
          <span>
            <img
              src="@/assets/images/icons/attachment-icon-v2.svg"
              alt=""
            /> </span
          >SELECT FILE</el-button
        >
      </el-upload>
    </div>
    <!-- Attachment upload -->
    <div class="attachment-upload" v-loading="fileUploadLoading">
      <a
        v-if="selectedFileName"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="content">
          <div class="icon">
            <img
              src="@/assets/images/icons/attachments/attachments_0.svg"
              alt="icon"
              class="img-fluid"
            />
          </div>
          <div class="text">
            <p>
              {{ selectedFileName }}
            </p>
          </div>
        </div>
        <ul class="actions">
          <li>
            <el-button @click="remove" class="remove-button">
              <el-icon><close /></el-icon>
            </el-button>
          </li>
          <li>
            <el-button
              class="upload-button"
              @click="uploadSelectedDocument"
              :disabled="!selectedFile ? true : false"
            >
              <el-icon><Upload /></el-icon>
            </el-button>
          </li>
        </ul>
      </a>
    </div>

    <div v-if="!noAttachments" class="attachment-uploaded">
      <ul>
        <li v-for="(doc, index) of allAttachments" :key="index">
          <div class="content" @click="downloadAttachment(doc)">
            <div class="icon">
              <img
                src="@/assets/images/icons/attachments/attachments_0.svg"
                alt="icon"
                class="img-fluid"
              />
            </div>
            <p class="text">
              <b style="color: blue">{{
                doc.category ? doc.category + " -" : ""
              }}</b>
              {{
                doc.metadata && doc.metadata.original_name
                  ? doc.metadata.original_name
                  : ""
              }}
            </p>
          </div>
          <button
            class="remove-button"
            type="button"
            @click="onDeleteAttachment(doc)"
          >
            <p>Remove</p>
          </button>
        </li>
      </ul>
    </div>
    <div
      class="attachments-empty"
      v-if="noAttachments && !this.selectedFileName"
    >
      <p>
        You Can Manage Attachments <br />
        Here, Please Add To Start
      </p>
    </div>
    <div class="mini-reason-for-change">
      <ResonForChange
        v-if="takeReasonForChangeDialog"
        v-on:close="takeReasonForChangeDialog = false"
        v-on:reasonSubmit="onTakeAction"
        title="Reason for Remove"
      ></ResonForChange>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);

import moment from "moment";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import caseConstants from "@/config/constants/caseConstants";
export default {
  name: "Attachments",
  mixins: [UserPermissionsHelper],
  components: {
    ResonForChange,
  },
  computed: {
    ...mapGetters("pendingCases", [
      "getsinglePatientDetails",
      "getFileUploadURLForAttachments",
      "getFileUploadRefIdForAttachment",
      "getAttachmentUploadStatusUpdated",
      "getAttachmentUploadStatus",
      "getAttachmentDeleteStatus",
    ]),

    ...mapGetters("respiratoryFileUpload", ["getFileDownloadUrl"]),
    isCaseCompleted() {
      if (!this.getsinglePatientDetails) {
        return false;
      }
      return (
        this.getsinglePatientDetails.status === "COMPLETE" ||
        this.getsinglePatientDetails.status === "REJECTED"
      );
    },
  },

  mounted() {
    this.checkCaseInformation();
  },
  data() {
    return {
      noAttachments: false,
      selectedFile: null,
      selectedFileName: null,
      caseId: "",
      allAttachments: [],
      loadingText: "",
      loading: false,
      fileUploadLoading: false,
      takeReasonForChangeDialog: false,
      selectedNote: null,
      attachmentsOptions: caseConstants.ATTACHMENTS_DROPDOWN,
      category: "",
    };
  },
  methods: {
    onDeleteAttachment(doc) {
      this.takeReasonForChangeDialog = true;
      this.selectedNote = doc;
    },
    onTakeAction(reason) {
      this.deleteAttachment(reason);
    },

    uploadFile(file) {
      this.selectedFile = file.raw;
      this.selectedFileName = file.raw.name;
      this.getFileUploadUrl(file);
    },
    remove() {
      (this.selectedFile = null), (this.selectedFileName = "");
    },
    async getFileUploadUrl(file) {
      try {
        this.loading = true;
        let data = {
          file: file.raw.name,
          file_type: file.raw.type,
          file_size: file.raw.size / 1000,
          pending_case_id: this.caseId,
          type: "case-attachments-upload",
        };
        if (this.category) {
          data.category = this.category;
        }
        await this.$store.dispatch("pendingCases/fetchDocumentUploadUrl", data);
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async uploadSelectedDocument() {
      this.fileUploadLoading = true;
      this.loadingText = "Uploading Document...";
      // uploding to S3
      let params = {
        file: this.selectedFile,
        upload_url: this.getFileUploadURLForAttachments,
      };

      await this.$store.dispatch(
        "pendingCases/uploadDocumentToGeneratedUrl",
        params
      );

      if (this.getAttachmentUploadStatus) {
        // UPDATEING STATUS
        let params = {
          hash: this.getFileUploadRefIdForAttachment,
          pending_case_id: this.caseId,
          type: "case-attachments-upload",
        };
        await this.$store.dispatch(
          "pendingCases/updateDocumentUploadStatus",
          params
        );
        if (this.getAttachmentUploadStatusUpdated) {
          successNotification("Attachment added successfully");
          this.selectedFileName = "";
          this.selectedFile = null;
          await this.checkCaseInformation();
        } else {
          this.$message("Sorry ! Error while file uploading");
        }
      } else {
        this.$message("Sorry ! Error while file uploading");
      }
      this.fileUploadLoading = false;
    },

    async deleteAttachment(reason) {
      let params = {
        case_id: this.caseId,
        id: this.selectedNote._id,
        data_update_reason: reason,
      };

      await this.$store.dispatch("pendingCases/deleteAttachment", params);

      if (this.getAttachmentDeleteStatus) {
        successNotification("Attachment deleted successfully");
        this.checkCaseInformation();
      }
    },

    async downloadAttachment(doc) {
      let routerData = this.$router.resolve({
        name: "ViewAttachments",
        params: {
          path: doc.path,
        },
      });
      window.open(routerData.href, "_blank");
    },

    async checkCaseInformation() {
      this.loading = true;
      this.fileUploadLoading = false;
      this.caseId = this.$route.params.case_id;
      if (!this.caseId) {
        this.loading = false;
        this.$router.push({
          to: "/pendingCases",
        });
      } else {
        await this.$store.dispatch("pendingCases/fetchSingleCaseInformation", {
          case_id: this.caseId,
        });
        if (!this.getsinglePatientDetails) {
          this.disablePatientInformation = true;
        }
        if (
          this.getsinglePatientDetails &&
          this.getsinglePatientDetails.attachments
        ) {
          this.allAttachments = this.getsinglePatientDetails.attachments || [];
          this.allAttachments = this.allAttachments.sort(
            (a, b) => moment(b.created_at) - moment(a.created_at)
          );
          this.noAttachments = this.allAttachments.length ? false : true;
        }
      }
      this.loading = false;
    },
  },
};
</script>
<style lang="scss">
.mini-reason-for-change {
  .el-dialog {
    width: 28%;
    height: 210px !important;
    margin-top: 20vh;
  }
}
</style>
